export default "https://cdn-static.gokick.com/assets/0f3104c02f0c7e58561d070a1e1ba5e916429e4c/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";